import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { fontRoboto } from "shared/lib/styles";

export const Container = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  block-size: 22.4px;
  margin-block: 20px 20px;

  &:empty {
    display: none;
  }
`;

export const Label = styled.div`
  font-weight: 700;
  font-size: 14px;
  line-height: 22.4px;
  white-space: nowrap;
`;

type StyledNavBarItemProps = {
  $isSelected?: boolean;
};

export const StyledNavBarItem = styled.div<StyledNavBarItemProps>`
  position: relative;

  display: flex;
  align-items: center;

  color: #000000;
  font-weight: ${props => (props.$isSelected ? 700 : 400)};
  font-size: 14px;
  font-family: ${fontRoboto};
  line-height: 22.4px;
  white-space: nowrap;
`;

type StyledNavBarProps = {
  $isSuperTopic: boolean;
};

export const StyledNavBar = styled.div<StyledNavBarProps>`
  scrollbar-width: none;

  display: flex;
  align-items: center;

  overflow-x: scroll;

  touch-action: pan-x;

  ${props =>
    props.$isSuperTopic
      ? css`
          ${StyledNavBarItem} + ${StyledNavBarItem} {
            margin-inline-start: 28px;

            &::after {
              position: absolute;
              inset-inline-start: -16px;
              content: "";

              inline-size: 4px;
              block-size: 4px;

              border-radius: 50%;

              background-color: #000000;
            }
          }
        `
      : css`
          ${StyledNavBarItem} + ${StyledNavBarItem} {
            margin-inline-start: 20px;
          }
        `}
`;
